"use strict";

export { TollingVisionServiceClient } from "./generated/TollingVisionServiceServiceClientPb";
export {
  Status,
  ResultType,
  Error,
  SignType,
  Point,
  Region,
  Quadrilateral,
  Image,
  Plate,
  Mmr,
  Color,
  Sign,
  Vehicle,
  LicenseService,
  LicenseServiceStatus,
  SearchRequest,
  EventRequest,
  ErrorResponse,
  SearchResponse,
  EventResult,
  PartialResult,
  EventResponse,
  ServerStatusRequest,
  ServerStatusResponse,
  LicenseServiceStatusRequest,
  LicenseServiceStatusResponse,
} from "./generated/TollingVisionService_pb";

export { HealthClient } from "./generated/HealthServiceClientPb";
export { HealthCheckRequest, HealthCheckResponse } from "./generated/Health_pb";
export { ServerReflectionClient } from "./generated/ReflectionServiceClientPb";
export {
  ServerReflectionRequest,
  ServerReflectionResponse,
} from "./generated/Reflection_pb";
